import styled, { css, keyframes } from 'styled-components';

import { getMedia, percent } from '../../../helpers/layout';

export const TelevisionContainer = styled.div`
    display: inline-block;
    user-select: none;
`;

export const TelevisionPicture = styled.picture`
    display: block;
`;

export const TelevisionPictureSource = styled.img`
    display: block;
    width: ${percent(1080, 1975)}vh;
    max-width: ${percent(1920, 1975)}vw;
    z-index: 10;
    position: relative;
    pointer-events: none;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        width: ${percent(750, 1260)}vh;
        max-width: ${percent(1366, 1260)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        max-width: none;
        ${({ mod }) => {
            if (mod === 'sectionFunctions') {
                return css`width: ${percent(768, 1195)}vw;`;
            } else if (mod === 'sectionArchive') {
                return css`width: ${percent(768, 1364)}vw;`;
            } else {
                return css`width: ${percent(768, 1100)}vw;`;
            }
        }}
    }

    @media only screen and ${getMedia('phone')} {
        max-width: none;
        ${({ mod }) => {
            if (mod === 'sectionFunctions') {
                return css`width: ${percent(320, 514)}vw;`;
            } else if (mod === 'sectionArchive') {
                return css`width: ${percent(320, 769)}vw;`;
            } else {
                return css`width: ${percent(320, 875)}vw;`;
            }
        }}
    }
`;

export const TelevisionContentWrapper = styled.div`
    position: absolute;
    z-index: 1;
    top: ${percent(1195, 29)}%;
    left: ${percent(2588, 542)}%;
    width: ${percent(2588, 1385)}%;
    height: ${percent(1195, 781)}%;
    background-color: #000;
`;

export const TelevisionContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const TelevisionPoster = styled(TelevisionContent)`
    transition: opacity 0.3s ease-out;

    ${({ isPlaying, onClick }) => {
        if (isPlaying) {
            return css`opacity: 0;`;
        } else if (onClick !== undefined) {
            return css`
                cursor: pointer;
            `;
        }
    }}

    @media only screen and ${getMedia('tablet')} {
        pointer-events: none;
    }
`;

const rotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

export const TelevisionPreloader = styled.img`
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${percent(2588, 210)}%;
    animation: ${rotate} 1s linear infinite;
    z-index: 1;
`;

const light = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

const fade = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const TelevisionLight = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    transition: opacity 0.3s ease-out;

    &:nth-child(1) {
        opacity: 1;
    }

    ${({ isNoDynamic, isPlaying }) => {
        if (isNoDynamic && isPlaying) {
            return css`
                &:nth-child(2),
                &:nth-child(3) {
                    animation: ${fade} 0.3s linear forwards;
                }
            `;
        } else if (!isNoDynamic && isPlaying) {
            return css`
                &:nth-child(1) {
                    animation: ${light} 1s linear infinite;
                }

                &:nth-child(2) {
                    animation: ${light} 1s linear infinite 0.5s;
                }
            `;
        }
    }}
`;

export const TelevisionLightContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
`;
